import { createContext } from "react";


export const TribeIsUpdatedContext = createContext();